import { Component } from '@angular/core';
import { MagicBarConversationService } from './magic-bar-converstaion.service';

@Component({
    standalone: false,
    selector: 'app-magic-bar-conversation',
  templateUrl: './magic-bar-conversation.component.html',
  styleUrl: './magic-bar-conversation.component.scss'
})
export class MagicBarConversationComponent {
  componentName = this.magicBarConversationService.componentName;

  constructor(
    private magicBarConversationService: MagicBarConversationService,
  ) { }


  setComponent(componentName: string) {
    this.magicBarConversationService.setComponent(componentName);
  }
}
